module.exports = __webpack_public_path__ + "static/media/9DESA19.ae43b395.jpg";